// extracted by mini-css-extract-plugin
module.exports = {"reportContainer":"AnalyticalReportCard-module--reportContainer--1W01x","downloadLink":"AnalyticalReportCard-module--downloadLink--3pB54"};